import React, { useState } from 'react'
import { BrowserView } from 'react-device-detect';
import {
  Badge, Button, ButtonDropdown, Container, DropdownMenu, DropdownItem, DropdownToggle, Row, Col, Form, Input, InputGroup, Navbar, Nav,
  NavLink, NavItem,
} from 'reactstrap';
import HttpClient from '../../utils/HttpClient';
import { SEARCH_TAB, WRITE_TAB, VIEW_TAB, EDITOR_TAB, PROFILE_TAB, NEW_DOCUMENT_ACTION } from '../../constants';
import { ReactComponent as ProfileSVG } from "../../svgs/person_24dp_0D79F2.svg";
import { ReactComponent as MenuIcon } from "./view_document_page/icons/MenuIcon";
import style from './Header.module.css';

const LOGO = '/images/mmdok_vit_svart.png';
const CREATE_ICON = '/images/createDocument.png';

const Header = ({ activeTab, metadata, documentCount, documents,
  changeTab, changeLang, exportAsDip, filter, searchDocumentsFreetext, strings }) => {
  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);

  const handleKeyUp = (e) => {
    if (e.keyCode == 65) {
      console.log("filter:" + e.target.value);
      searchDocumentsFreetext(e.target.value);
    }
  }

  const handleFreeTextSearch = () => {
    const searchInput = document.querySelector('input[type="text"]');
    if (searchInput) {
      searchDocumentsFreetext(searchInput.value);
    }
  }

  const handleLogout = () => {
    new HttpClient().logout();
    window.location.reload();
  }

  const changeLanguage = (lng) => {
    console.log("new language:" + lng)
    changeLang(lng);
  }

  const exportDip = () => {
    const ids = [];
    for (const d of documents) {
      if (d.id && d.id.value)
        ids.push(d.id);
    }
    exportAsDip(ids);
  }

  const openGraphs = async () => {
    const httpClient = new HttpClient();
    const serverUrl = httpClient.getServerUrl();
    const token = sessionStorage.getItem('access_token');
    
    try {
      const response = await fetch(`${serverUrl}/graph/session`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      const data = await response.json();
      
      if (data.success) {
        window.open(data.redirectUrl, '_blank');
      } else {
        console.error('Failed to create graph session:', data);
        alert(strings['FailedToOpenGraph'] || 'Failed to open graph page');
      }
    } catch (error) {
      console.error('Failed to open graph:', error);
      alert(strings['FailedToOpenGraph'] || 'Failed to open graph page');
    }
  }

  const getLoggedInInfo = () => {
    const email = sessionStorage.getItem('email');
    if (email && email != 'undefined') {
      return (email);
    }
    else {
      return (null);
    }
  }

  // Get the logged-in user's email
  const email = getLoggedInInfo();

  return (
    <header>
      <Navbar fixed="top" expand="xs" className="d-flex shadow-sm bg-white" style={{ minHeight: 70, transition: 'all 0.3s ease', borderBottom: '1px solid #dee2e6' }}>
        <Container>

          <Row noGutters className="position-relative w-100 align-items-center">

            <Col className="d-none d-lg-flex d-lg-flex justify-content-center">
              <NavItem className="d-flex align-items-center">
                <NavLink className="font-weight-bold text-dark d-flex align-items-center" href="/">
                  <img src="/images/tinylogowide.svg" alt="sv" style={{ width: 120, height: 50, transition: 'transform 0.2s' }} className="hover-scale" />
                </NavLink>
              </NavItem>
            </Col>
            <Col className="d-flex d-lg-flex justify-content-start">
              <Nav className={style.tabNav} navbar>
                <style>
                  {`
                    .hover-scale:hover {
                      transform: scale(1.05);
                    }
                  `}
                </style>

                <NavItem>
                  <NavLink 
                    className={`${style.tabItem} ${activeTab === SEARCH_TAB ? style.tabItemActive : ''}`}
                    onClick={() => { changeTab(SEARCH_TAB); }}
                  >
                    {strings['Search']}
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink 
                    className={`${style.tabItem} ${activeTab === WRITE_TAB ? style.tabItemActive : ''}`}
                    onClick={() => { changeTab(WRITE_TAB, metadata, NEW_DOCUMENT_ACTION); }}
                  >
                    {strings['Upload']}
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink 
                    className={`${style.tabItem} ${activeTab === VIEW_TAB ? style.tabItemActive : ''}`}
                    onClick={() => { changeTab(VIEW_TAB, metadata); }}
                  >
                    {strings['View']}
                  </NavLink>
                </NavItem>

                <NavItem className="d-flex align-items-center">
                  <NavLink className={activeTab === EDITOR_TAB ? "font-weight-bold" : ""}
                    onClick={() => { changeTab(EDITOR_TAB, metadata, NEW_DOCUMENT_ACTION); }}><img src="/images/createDocument.png" alt="sv" style={{ width: 30, height: 30 }} />
                  </NavLink>
                </NavItem>

                <NavItem className="d-flex align-items-center">
                  <NavLink className={activeTab === PROFILE_TAB ? "font-weight-bold" : ""}
                    onClick={() => { changeTab(PROFILE_TAB, metadata); }}>
                    <ProfileSVG />
                  </NavLink>
                </NavItem>

                <NavItem className="d-flex align-items-center">
                  <NavLink onClick={openGraphs} title={strings['Graphs'] || 'Graphs'}>
                    📊
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>

            <Col className="d-none d-md-flex justify-content-xs-start justify-content-lg-center">
              <Badge color="success">{documentCount}</Badge>
            </Col>

            <Col md={3} lg={3} className="d-none d-md-flex justify-content-xs-start justify-content-lg-center">
              <InputGroup>
                <Input type="text" placeholder={strings['FreeTextSearch']} style={{ flex: '1 1 auto', minWidth: '125px' }}/>
                <Button key="freetextsearch" id="freetextsearch" color="primary" onClick={handleFreeTextSearch} style={{ flex: '0 0 auto', whiteSpace: 'nowrap' } }>
                  {strings['Search']}
                </Button>
              </InputGroup>
            </Col>

            <Col className="d-none d-flex justify-content-end">
              <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle className={style.menuButton}>
                  <MenuIcon className={style.menuIcon} />
                  {strings['Menu']}
                </DropdownToggle>
                <DropdownMenu right className={style.dropdownMenu}>
                  <DropdownItem className={style.dropdownItem} onClick={() => handleLogout()}>
                    {strings['SignOut']}
                  </DropdownItem>
                  <DropdownItem divider className={style.dropdownDivider} />
                  <DropdownItem header className={style.dropdownHeader}>{strings['Language']}</DropdownItem>
                  <DropdownItem className={style.dropdownItem} onClick={() => changeLanguage("en")}>
                    <img src="/images/eng.png" alt="en" style={{ width: 20, height: 20 }} />
                    English
                  </DropdownItem>
                  <DropdownItem className={style.dropdownItem} onClick={() => changeLanguage("sv")}>
                    <img src="/images/swe.png" alt="sv" style={{ width: 20, height: 20 }} />
                    Svenska
                  </DropdownItem>
                  <DropdownItem divider className={style.dropdownDivider} />
                  {email && (
                    <DropdownItem header className={style.dropdownHeader} title="Din epost" style={{ fontWeight: 400, color: '#0D79F2', opacity: 0.95, fontSize: 13 }}>
                      {email}
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </ButtonDropdown>
            </Col>

          </Row>
        </Container>
      </Navbar>
    </header>
  )
}

/*
                  <DropdownItem divider />
                  <DropdownItem header>Exportera sökresultat</DropdownItem>
                  <DropdownItem onClick={() => exportDip()}>Som DIP</DropdownItem> 
*/
/*

            <Col className="d-none d-md-flex justify-content-xs-start justify-content-lg-center">
              <Form inline>
                <Input type="text" className="mr-3" placeholder={strings['Filter']} onKeyUp={(v) => handleKeyUp(v)} />
              </Form>
            </Col>
*/
/*
<DropdownItem onClick={() => onShopChange(shopToMap)}>
  <i class="some-icon" />
  <h3>Some heading</h3>
  <p>Some sub heading</p>{' '}
</DropdownItem>
*/

export default Header